import { useEffect } from "react";
import { getGroupId, isGroupChild, isGroupParent } from "./TableGroupingColumn";
import { areRowsEqual } from "./utils";
import usePrevious from "@restart/hooks/usePrevious";
export const useUpdateSelectionOnDataChange = ({ data, selected, selectionMode, onSelectionChange, dataItemKey, grouping, }) => {
    const previousData = usePrevious(data);
    useEffect(() => {
        // if data has changed
        if (onSelectionChange && selected && previousData && (previousData === null || previousData === void 0 ? void 0 : previousData.length) !== (data === null || data === void 0 ? void 0 : data.length)) {
            if (selectionMode !== "single" && selected.allSelected) {
                const filteredData = data ? data.filter((item) => !isGroupParent(item)) : [];
                onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange({ allSelected: true, items: filteredData || [] });
            }
            else if (grouping) {
                let allSelectedRowsFromGroups = [];
                grouping.forEach((groupingConfigRow, groupId) => {
                    if (groupingConfigRow.selected && data) {
                        allSelectedRowsFromGroups = allSelectedRowsFromGroups.concat(data.filter((item) => isGroupChild(item) && getGroupId(item) === groupId));
                    }
                });
                const rowsNotAlreadySelected = allSelectedRowsFromGroups.filter((groupRow) => !selected.items.find((selectedRow) => areRowsEqual(groupRow, selectedRow, dataItemKey)));
                if (rowsNotAlreadySelected.length) {
                    onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(Object.assign(Object.assign({}, selected), { items: [...selected.items, ...rowsNotAlreadySelected] }));
                }
            }
        }
    }, [data, selected, grouping, onSelectionChange]);
};
//# sourceMappingURL=useUpdateSelectionOnDataChange.js.map